<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-container>
        <b-row v-if="apiError">
            <b-col>
                <b-alert variant="warning" show>{{apiError}}</b-alert>
            </b-col>
        </b-row>
        <spinner v-if="busy"></spinner>
        <b-row v-else>
            <b-col md="3">
                <b-button v-b-modal.contentNewListModal class="mb-2"
                          @click.stop="addNewListItem()">
                    <i class="fal fa-plus"></i> New List
                </b-button>
                <b-nav vertical pills class="mt-4 text-left">
                    <b-row :key="listItem.id"
                           v-for="(listItem) in contentList">
                        <b-col>
                            <b-nav-item exact-active-class="active"
                                        :to="{ name: 'content-list' , params: {resource: listItem.id}}"
                                        >{{listItem.label}}
                            </b-nav-item>
                        </b-col>
                        <b-col md="auto">
                            <b-button variant="link" v-b-modal.contentNewListModal @click.stop="editList(listItem)">
                                <i class="fal fa-edit"></i></b-button>
                            <!--<b-button variant="link" @click="deleteList(listItem.id)">-->
                                <!--<i class="fal fa-trash-alt"></i>-->
                            <!--</b-button>-->
                        </b-col>
                    </b-row>

                </b-nav>
            </b-col>
            <b-col>
                <b-button v-b-modal.contentListModal class="mb-2 float-right"

                          @click.stop="addNewItem(activeListItem)">
                    <i class="fal fa-plus"></i> New List Item
                </b-button>
                <b-table v-if="activeListItem" responsive striped hover small :items="activeListItem.contentList"
                         :fields="[...activeListItem.fields, { key: 'actions', class: 'table-action-column' }]">
                    <template v-slot:cell(actions)="row">
                        <b-button variant="link" v-b-modal.contentListModal
                                  @click.stop="editItem(activeListItem, row.item)">
                            <i class="fal fa-edit"></i></b-button>
                        <b-button variant="link" @click="deleteListItem(row.item.id)">
                            <i class="fal fa-trash-alt"></i>
                        </b-button>
                    </template>
                    <template v-for="(field, index) in activeListItem.fields" v-slot:[`cell(${field})`]="data">
                        <value-render v-bind:key="index" :item="data.item.contentDataSet[field]"/>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <content-list-modal
                @saved="loadContentList"
                ref="contentListModal"
                id="contentListModal"
                :page="selectedPageEntity">
        </content-list-modal>
        <content-new-list-modal
                @saved="loadContentList"
                ref="contentNewListModal"
                id="contentNewListModal">
        </content-new-list-modal>
    </b-container>
</template>

<script>

    import ContentAPI from "@shared/_api/cms/content";
    import ValueRenderer from "../helper/ValueRenderer";
    import ContentListModal from "./ContentListModal";
    import Spinner from "../../../viewsShop/components/ui/Spinner";
    import ContentNewListModal from "./ContentNewListModal";

    export default {
        name: 'Template',
        props: {
            id: String
        },
        components: {
            "content-list-modal": ContentListModal,
            "content-new-list-modal": ContentNewListModal,
            'spinner': Spinner,
            "value-render": ValueRenderer
        },
        data() {
            return {
                busy: false,
                apiError: null,
                contentList: [],
                selectedPageEntity: {},
                listItemId: null
            };
        },
        computed: {
            activeListItem() {
                return this.contentList.find(i => i.id == this.listItemId);
            },
        },
        methods: {
            addNewListItem: function () {
                this.$refs.contentNewListModal.manageEntity({});
            },
            editList: function (list) {
                this.$refs.contentNewListModal.manageEntity({
                    id: list.id,
                    name: list.name,
                    label: list.label
                }, list.template.id);
            },
            deleteList: function (listId) {
                this.busy = true;
                ContentAPI.deleteList(listId).catch(error => {
                    this.apiError = error;
                }).finally(() => {
                    this.busy = false;
                    this.loadContentList();
                });
            },
            addNewItem: function (list) {
                let data = {
                    template: list.template,
                    contentDataSet: {},
                    listId: list.id
                };

                list.fields.forEach(field => {
                    data.contentDataSet[field] = {
                        value: '',
                        templateField: list.schema.find(obj => {
                            return obj.name === field
                        })
                    };
                });
                this.$refs.contentListModal.manageEntity(data);
            },
            editItem: function (list, content) {
                let data = {
                    ...content,
                    listId: list.id
                };

                this.$refs.contentListModal.manageEntity(data);
            },
            loadContentList: function () {
                this.busy = true;
                ContentAPI.fetchList().then(contentList => {
                    this.contentList = contentList

                    if (!this.listItemId && this.contentList.length > 0) {
                        this.$router.push({params: {resource: this.contentList[0].id}});
                    }
                }).catch(error => {
                    this.apiError = error;
                }).finally(() => {
                    this.busy = false;
                })
            },
            deleteListItem(contentLid) {
                this.busy = true;
                ContentAPI.delete(contentLid).catch(error => {
                    this.apiError = error;
                }).finally(() => {
                    this.busy = false;
                    this.loadContentList();
                });
            }
        },
        mounted() {
            this.loadContentList();
            this.listItemId = this.$route.params.resource;
        },
        beforeRouteUpdate(to, from, next) {
            this.listItemId = to.params.resource;
            next();
        }
    }

</script>